import Vue from 'vue'
import { DataState, AppState } from '@/state'
import { API } from './core'

export class User {
  initial () {
    return this.tagname[0].toUpperCase()
  }
  profileUrl () {
    return `/people/@${this.tagname}/`
  }

  updateFromServer (state) {
    return API.instance().get('/profile/', { params: { key: this.key } }).then((resp) => {
      const updatedUser = resp.data.data.user
      if (resp.data.data.firebase_token) {
        updatedUser.firebaseToken = resp.data.data.firebase_token
      }

      Object.entries(updatedUser).forEach(obj => Vue.set(this, obj[0], obj[1]))
      if (state) {
        state.changeToLoaded()
      }
      User.Cached[updatedUser.key] = this
    })
  }

  static createFromJson (raw) {
    let user = new User()
    user = Object.assign(user, raw)
    User.Cached[user.key] = user
    return user
  }

  static fromKey (userKey) {
    const user = new User()
    user.key = userKey
    user.tagname = '-'
    return user
  }

  static fetch (userKey) {
    return this.fromKey(userKey).updateFromServer()
  }

  static useCachedOrFetch (userKey) {
    if (User.Cached[userKey]) {
      return User.Cached[userKey]
    }
    const user = this.fromKey(userKey)
    User.Cached[userKey] = user
    if (userKey && userKey !== '0') {
      user.updateFromServer()
    }
    return user
  }

  static search (q) {
    return API.instance().get('/people/search/', {
      cancelToken: API.searchCancelToken.token,
      params: { q }
    })
  }
}

User.Cached = {}
User.MeFollowing = null

export const ActiveUser = {
  user: User.fromKey(null),
  state: DataState.newLoading()
}

AppState.instance.user = ActiveUser.user

export class UserKey {
  constructor (key) {
    this.key = key
    this.loadedUser = null
  }
  get user () {
    if (this.loadedUser === null) {
      this.loadedUser = User.useCachedOrFetch(this.key)
    }
    return this.loadedUser
  }

  getUser () {
    return this.user
  }

  toString () {
    return this.key
  }
}
